<template>
  <div class="d-flex">
    <MainBarMenuV2 />
    <div class="layout-content container-fluid">
      <HeadingUser />
      <div class="col-10 mx-auto my-5">
        <Breadcrumb :items="breadcrumb" />
        <div class="d-flex justify-content-between align-items-center">
          <Typography text="Evaluar proceso" variant="h1" class="m-0" />
        </div>

        <Typography
          text="Antes de evaluar el riesgo identifica las condiciones y/o características del proceso, esto te ayudará a evaluar la materialización del riesgo e impacto."
          variant="body" class="m-0 pt-3 mt-3 max-w-75" />
        <Typography variant="body" class="m-0 pt-3 mt-3"><b>Radicado:</b> {{file_number}}</Typography>
        <section class="w-100">
          <form onsubmit="return false" @submit="submitData">
            <div :class="['row col-12 p-0 min-h-245 justify-content-between mx-0']">
              <Select v-for="impact in fields.impact" :label="impact.label" :key="impact.id" :name="impact.name"
                :options="impact.options" :value="formData[impact.name]" v-model="formData[impact.name]"
                :errors="computedErrors" @input="validate(impact.name)" required col="6" class="px-1 mt-5" />
              <Select v-for="probability in fields.probability" :label="probability.label" :key="probability.id"
                :name="probability.name" :options="probability.options" :value="formData[probability.name]"
                v-model="formData[probability.name]" :errors="computedErrors" @input="validate(probability.name)"
                required col="6" class="px-1 mt-5" />
            </div>
            <div class="container-buttons">
              <Button label="Cancelar" showIcon icon="cancel" variant="secondary" colorIcon="#5D5FEF"
                @click="confirmCancel" />
              <Button label="Evaluar" type="submit" showIcon icon="check" variant="primary" class="ml-4" />
            </div>
          </form>
        </section>
      </div>
      <!--Modal Section-->
      <div>
        <b-modal id="modal-confirm" centered hide-footer>
          <div class="text-center mb-4">
            <img src="@/assets/images/icons/warning_.svg" width="60px" height="60px" class="mx-auto" />
          </div>
          <Typography text="¿Estás seguro de cancelar esta evaluación?" variant="h3" class="text-center" />
          <div class="row justify-content-center mt-4">
            <Button label="Si, Cancelar" variant="secondary" @click="goBack" />
            <Button label="Seguir Evaluando" variant="primary" class="ml-4" @click="closeModal('modal-confirm')" />
          </div>
        </b-modal>
        <b-modal id="modal-message" centered hide-footer>
          <div class="text-center mb-4">
            <img src="@/assets/images/icons/checkbox-circle-line.svg" width="60px" height="60px" class="mx-auto" />
          </div>
          <Typography text="¡Evaluación completada!" variant="h2" class="text-center" />
          <Typography text="El proceso ha sido asignado a nivel de riesgo" variant="body" class="text-center" />
          <p class="text-center">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.333008 0.5H13.0917C13.1501 0.499902 13.2075 0.515165 13.2582 0.544257C13.3089 0.57335 13.351 0.615251 13.3804 0.66576C13.4098 0.716269 13.4253 0.773612 13.4256 0.832041C13.4258 0.89047 13.4107 0.947932 13.3817 0.998667L10.9997 5.16667L13.3817 9.33467C13.4107 9.3854 13.4258 9.44286 13.4256 9.50129C13.4253 9.55972 13.4098 9.61707 13.3804 9.66757C13.351 9.71808 13.3089 9.75998 13.2582 9.78908C13.2075 9.81817 13.1501 9.83343 13.0917 9.83333H1.66634V13.1667H0.333008V0.5Z"
                :fill="result.color" />
            </svg>
            {{result.name}}</p>
          <div class="row justify-content-center mt-4">
            <Button label="Entendido" variant="primary" @click="goBack" />
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import useControllers from "@/controllers";
const { useScreenHooks } = useControllers();
const { useLegal } = useScreenHooks();
const { useProcess } = useLegal();
const { useEvaluate } = useProcess();

export default useEvaluate;
</script>

<style  lang="scss" scoped src="./EvaluateProcess.scss">

</style>